export const planTogetherSectionData = {
  youLabel: 'You',
  partnerLabel: 'Partner',
  plannerLabel: 'Planner',
  eyebrow: 'Multiple Editors',
  title: 'Plan together without sharing passwords.',
  content:
    'We’ve made it easy to invite your partner, planner, or mom to collaborate on your website without having to share accounts or passwords.',
} as const;
